import React from "react";
import {Link} from 'react-router-dom';
import bdimg24 from "../../images/frontend/icon-24hr.png";
import book from "../../images/frontend/icon-book.png";
import ambassador from "../../images/frontend/icon-ambassador.png";
import andorid from "../../images/frontend/android-bn.png";
import safe1 from "../../images/frontend/safe1.png";
import safe2 from "../../images/frontend/safe2.png";
import safe3 from "../../images/frontend/safe3.png";
import pay16 from "../../images/frontend/pay16.png";
import pay22 from "../../images/frontend/pay22.png";
import pay33 from "../../images/frontend/pay33.png";
import pay34 from "../../images/frontend/pay34.png";
import pay45 from "../../images/frontend/pay45.png";
import pay47 from "../../images/frontend/pay47.png";
import pay60 from "../../images/frontend/pay60.png";
import pay61 from "../../images/frontend/pay61.png";
import pay91 from "../../images/frontend/pay91.png";
import Youtube from "../../images/frontend/Youtube.png";
import Twitter from "../../images/frontend/Twitter.png";
import Telegram from "../../images/frontend/Telegram.png";
import Pinterest from "../../images/frontend/Pinterest.png";
import Instagram from "../../images/frontend/Instagram.png";
import FaceBook from "../../images/frontend/FaceBook.png";
import logoa from "../../images/logo.png";
import "./Footernew.css"; 
import { Container, Row, Col, Card } from "react-bootstrap";




  const BaseUrl = 'https://backoffice.betfair75.com/';
  var home_menu = BaseUrl + "public/appssource/sports_icons/home_menu.png";
  var casino_menu = BaseUrl + "public/appssource/sports_icons/casino_menu.png";
  var sports_menu = BaseUrl + "public/appssource/sports_icons/sports_menu.png";
  var bonus_menu = BaseUrl + "public/appssource/sports_icons/bonus_menu.png"; 
  const auth_token = localStorage.getItem('auth_token');


const InfoSection = () => (
  <Container fluid className="py-4 text-center">
    <Row className="text-center">
      <Col className="info-card col-xl-3 col-xxl-3 col-lg-3 col-md-3 col-sm-3 col-3 int-col p-1">
        <img src={bdimg24} alt="" className="me-3 rounded" width={95} />
        <h5>কাস্টমার সার্পোট</h5>
        <p>২৪/৭ আপনারদের সেবা নিশ্চিৎ</p>
        <a href="#" className="info-link">এখনই এগ্রেযার করুন</a>
      </Col>
      <Col className="info-card col-xl-3 col-xxl-3 col-lg-3 col-md-3 col-sm-3 col-3 int-col p-1">
        <img src={book} alt="" className="me-3 rounded" width={95} />
        <h5>নতুন সদস্যদের জন্যে গাইড</h5>
        <p>প্রথম সুষ্ঠু এবং সাহায্যকারী গাইড</p>
        <a href="#" className="info-link">এখনই এগ্রেযার করুন</a>
      </Col>
      <Col className="info-card col-xl-3 col-xxl-3 col-lg-3 col-md-3 col-sm-3 col-3 int-col p-1">
        <img src={ambassador} alt="" className="me-3 rounded" width={95} />
        <h5>ব্র্যান্ড অ্যাম্বাসেডর</h5>
        <p>সেলিব্রিটির সাথে খেলুন</p>
        <a href="#" className="info-link">এখনই যোগ করুন</a>
      </Col>
      <Col className="info-card col-xl-3 col-xxl-3 col-lg-3 col-md-3 col-sm-3 col-3 int-col p-1">
        <img src={andorid} alt="" className="me-3 rounded" width={100} />
        <h5>অ্যান্ড্রয়েডের জন্য</h5>
      </Col>
    </Row>
  </Container>
);

const PaymentMethods = () => (
  <Container fluid className="py-4 text-center">
    <Row>
      <Col xs={12} md={4} className="mb-3">
          <h5 className="section-title mb-2">দায়িত্বশীল গেমিং</h5>
          <div className="icon-group"> 
            <img src={safe1} alt="" className="me-3 rounded" width={90} />
            <img src={safe2} alt="" className="me-3 rounded" width={90} />
            <img src={safe3} alt="" className="me-3 rounded" width={90} />
            {/* Add more icons as needed */}
          </div>
      </Col>
      <Col xs={12} md={8} className="mb-3">
      <h5 className="section-title mb-2">পেমেন্ট পদ্ধতি</h5>
          <div className="icon-group">
          <img src={pay16} alt="" className="me-3 rounded"/>
          <img style={{ height: 'auto' }} src={pay22} alt="" className="me-3 rounded"/>
          <img style={{ height: 'auto' }} src={pay33} alt="" className="me-3 rounded"/>
          <img style={{ height: 'auto' }} src={pay34} alt="" className="me-3 rounded" />
          <img style={{ height: 'auto' }} src={pay45} alt="" className="me-3 rounded" />
          <img style={{ height: 'auto' }} src={pay47} alt="" className="me-3 rounded"/> 
          <img style={{ height: 'auto' }} src={pay60} alt="" className="me-3 rounded" /> 
          <img style={{ height: 'auto' }} src={pay61} alt="" className="me-3 rounded" /> 
          <img style={{ height: 'auto' }} src={pay91} alt="" className="me-3 rounded" /> 
            {/* Add more payment icons as needed */}
          </div>
      </Col>
    </Row>
  </Container>
);


const SocialLinks = () => (
  <Container className="p-2 mb-3">
    <Row>
      <Col xs={12}><h6 className="text-muted">কমিউনিটি ওয়েবসাইট</h6></Col>
      <Col xs={2} sm={1}><a href="https://facebook.com"><img src={Youtube} alt="" className="me-3 rounded" /> </a></Col>
      <Col xs={2} sm={1}><a href="https://instagram.com"><img src={Twitter} alt="" className="me-3 rounded" /> </a></Col>
      <Col xs={2} sm={1}><a href="https://pinterest.com"><img src={Telegram} alt="" className="me-3 rounded" /> </a></Col>
      <Col xs={2} sm={1}><a href="https://youtube.com"><img src={Pinterest} alt="" className="me-3 rounded" /> </a></Col>
      <Col xs={2} sm={1}><a href="https://telegram.org"><img src={Instagram} alt="" className="me-3 rounded" /> </a></Col>
      <Col xs={2} sm={1}><a href="https://telegram.org"><img src={FaceBook} alt="" className="me-3 rounded" /> </a></Col>
    </Row>
  </Container>
);

const DownPart = () => (
  <Container style={{ marginBottom: '100px' }} fluid className="text-center">
    
    <Row className="align-items-center">
      <Col xs={12} md={4} className="mb-3"><img src={logoa} alt="" width={60} /></Col>
      <Col xs={12} md={4}></Col>
      <Col xs={12} md={4}>
        <ul className="list-inline">
          <li className="list-inline-item"><a href="/affiliate">অ্যাফিলিয়েট</a></li>
          <li className="list-inline-item"><a href="/responsible-gaming">দায়িত্বশীল গেমিং</a></li>
          <li className="list-inline-item"><a href="/terms">শর্তাবলী</a></li>
          <li className="list-inline-item"><a href="/privacy-policy">গোপনীয়তা নীতি</a></li>
        </ul>
      </Col>
    </Row>
  </Container>
);

const Footer = () => (
  <>
    <InfoSection />
    <PaymentMethods />
    <SocialLinks />
    <DownPart />
    <footer className="mobilefutshow">
        <div className="footer-nav-wrapper" style={{ padding : '0px' }}>
            {auth_token ? (
              <>
                <Link className="footer-nav-single" to={"/"}>
                    <div className="menu-wrapper">
                        <img src={home_menu} alt="Home" width="30px" />
                        <span className="nav-text">Home</span>
                    </div>
                </Link>

                <Link className="footer-nav-single" to={"/sportsbook"}>
                    <div className="menu-wrapper">
                        <img src={sports_menu} alt="Home" width="30px" />
                        <span className="nav-text">Sports</span>
                    </div>
                </Link>
                <Link className="footer-nav-single" to={"/home-game/all-game"}>
                    <div className="menu-wrapper">
                        <img src={casino_menu} alt="Home" width="30px" />
                        <span className="nav-text">Casino</span>
                    </div>
                </Link>

              <Link className="footer-nav-single" to={"/bonus"}>
                  <div className="menu-wrapper">
                        <img src={bonus_menu} alt="Home" width="30px" />
                      <span className="nav-text">Bonus</span>
                  </div>
              </Link>
            </>
             ) : (
            <>
              <div class="footer-item green">
              <div class="flag-icon"></div>
                  <span>BDT ENG</span>
              </div>
                <div class="footer-item yellow"><Link to="?login=true">Login</Link></div>
                <div class="footer-item black"><Link to="/register"  style={{ color: 'white' }} >Sign up</Link></div>
            </>
          )}
        </div>
    </footer>
  </>
);

export default Footer;
